var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ApplicationRoot',{attrs:{"id":"applicationRoot"}})
}
var staticRenderFns = []

export { render, staticRenderFns }